<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">供应商</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-button
              class="btn btn-primary"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="submitQuery(1)"
          >刷新
          </el-button>
        </el-form-item>
        <!--<el-form-item>
            <el-button
                    class="btn btn-primary"
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    @click="activeType='add';detailVisible=true;saveModel={};"
            >添加
            </el-button>
        </el-form-item>-->
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>供应商列表</span>
    </div>
    <el-table highlight-current-row :data="sellers" border>
      <el-table-column align="center" label="用户信息">
        <template slot-scope="scope">
          <p>
            <el-image style="height: 45px; width: 45px; border-radius: 75px;border: rgb(241,242,244) solid 1px;"
                      :src="scope.row.iconPath">
              <div slot="error" class="image-slot">
                <el-image title="加载失败"
                          src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/qunyiguan/c6d05d1e8c33703186ec1f89743f979.png"/>
              </div>
            </el-image>
          </p>
          <p>昵称：{{ scope.row.nickname || '已失效' }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="企业名称" prop="companyName"/>
      <el-table-column align="center" label="企业法人" prop="companyUserName"/>
      <el-table-column align="center" label="企业类别" prop="companyType"/>
      <el-table-column align="center" label="企业性质" prop="companyNature"/>
      <el-table-column align="center" label="营业执照">
        <template slot-scope="scope">
          <el-image style="height: 100px; width: 100px;" :src="dynamicPath+scope.row.businessPath"
                    :preview-src-list="[[dynamicPath+scope.row.businessPath]]">
            <div slot="error" class="image-slot">
              <el-image
                  title="加载失败"
                  src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"
              />
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status === 'SUCCESS' ? '通过审核' : scope.row.status === 'NONE' ? '未审核' : '拒绝' }}
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-tooltip content="审核" placement="top" v-if="scope.row.status==='NONE'">
            <el-button type="primary" @click="checkSupplier(scope.row.id);"
                       icon="el-icon-s-check"
                       circle></el-button>
          </el-tooltip>
          <el-tooltip content="删除" placement="top">
            <el-button type="danger" @click="del(scope.row.id)" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <vue-pager
        :datafile="fillData"
        url="/supplier/pageSupplier"
        :query="query"
        ref="pager"
        :init="true"/>
    <supplier-detail ref="supplier-detail"/>
  </div>
</template>
<script>
import supplierDetail from "./components/supplier-detail.vue"

export default {
  data() {
    return {
      query: {},
      sellers: [],
      options: [],
      dynamicPath: config.dynamicResourcePath,
      statuses: [],
      statusMap: {},
    };
  },
  components: {
    supplierDetail
  },
  methods: {
    fillData(_response) {
      this.sellers = _response.items || [];
    },
    del(_id) {
      var _this = this;
      _this
          .$confirm("是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.$common.ajaxRequest({
              url: '/supplier/deleteSupplier',
              data: {
                supplierId: _id
              },
              success(response) {
                _this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 1000,
                  onClose: function () {
                    _this.submitQuery();
                  }
                });
              }
            });
          })
          .catch(() => {
            console.log("delete cancel");
          });
    },
    submitQuery(_num) {
      this.$refs.pager.gotoPage(_num);
    },
    checkSupplier(_supplierId) {
      this.$refs["supplier-detail"].openWindow(_supplierId)
    }
  }
};
</script>
<style scoped>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
